import { render, staticRenderFns } from "./contactIndex.vue?vue&type=template&id=58c20df5&scoped=true"
import script from "./contactIndex.vue?vue&type=script&lang=js"
export * from "./contactIndex.vue?vue&type=script&lang=js"
import style0 from "./contactIndex.vue?vue&type=style&index=0&id=58c20df5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c20df5",
  null
  
)

export default component.exports